(function checkboxPlugin(global) {
  "use strict";

  /**
  * Плагин для возможности редактирования грида
  * @class WebAccess.components.dataViews.gridPlugins.EditPlugin
  * @extends WebAccess.Plugin
  * @property {string} name Имя плагина.  
  * @since 5.2.0.1300
  */
  global.EditPlugin = WA.Plugin.extend({
    name: 'EditPlugin',
    _pending: null,
    // Грид. 
    _grid: null,
    _selectionModel: null,
    _exceptions: null,
    _bindedTables: [],
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Регистрация плагина.
    * @method WebAccess.components.dataViews.gridPlugins.EditPlugin#register
    * @param {WebAccess.components.dataViews.Grid} grid расширяемый объект(в данном конкреном случае - это грид).
    * @since 5.2.0.1300
    * @return {object} публичные методы доступные расширяемому объекту.
    */
    register: function (grid) {

      var me = this;
      me._exceptions = ['.contextmenu', '.rs_results', '.ui-datepicker', '.rs_tr_odd', '.rs_tr_even', '.rs_RefCaption'];
      me._grid = grid;
      me._grid.bind(WA.CMP.DV.Grid.EVENT.BEFORE_GRID_INIT, me._onGridBeforeInit, me);
      me._grid.bind(WA.CMP.DV.Grid.EVENT.GRID_INIT, me._onGridInit, me);
      me._grid.bind(WA.CMP.DV.Grid.EVENT.COLUMN_INIT, me._onColumnInit, me);
      me._bindedTables = [];

      log.info('GRID', 'Edit plugin registered');
      return {};
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Хэндлер события до инициализации грида.
    * @method WebAccess.components.dataViews.gridPlugins.EditPlugin#_onGridBeforeInit
    * @param {string} containerSelector селектор контейнера для грида.
    * @param {Object} dataView представление данных.
    * @param {Object} columns описания всех колонок.
    * @param {Object} settings настройки грида.
    * @private
    * @since 5.2.0.1100
    */
    _onGridBeforeInit: function (containerSelector, dataView, columns, byref_settings) {
      var me = this;
      byref_settings.enableCellNavigation = true,
      byref_settings.editable = true;
      byref_settings.autoEdit = true;
      //byref_settings.enableAddRow = true;      
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Обработчик события инициализации грида.
    * @method WebAccess.components.dataViews.gridPlugins.EditPlugin#_onGridInit
    * @private
    * @since 5.2.0.1100
    */
    _onGridInit: function (grid) {
      var me = this;

      // Для планшетов и сматфонов отключаем возможность выделять ячейки и строки, что бы заработала прокрутка.
      if (!WA.ENV.isTouch()) {
        me._selectionModel = new Slick.CellSelectionModel();
        grid.setSelectionModel(me._selectionModel);
      } else {
        me._selectionModel = new Slick.StubSelectionModel();
        grid.setSelectionModel(me._selectionModel);
      }

      grid.onCellChange.subscribe((e, args) => {
        const row = args['item'];
        const columns = grid.getColumns();
        const column = columns[args.cell];
        this._grid.fire('requisiteChange', column.id, row.id, row[column.id], row[column.field]);
      });

      grid.onEditorInit.subscribe(function (e, args) {
        var row = args['item'];
        var colNum = args['cell'];
        var columns = grid.getColumns();
        var column = columns[args.cell];
        var editor = args.editor;
        me._grid.fire('editorInit', column.id, row.id, row[column.id], row[column.field], editor);
      })

      grid.onBeforeCellEditorDestroy.subscribe(function (e, args) {
        me._grid.fire('editorDestroy', e, args);
      });

      grid.onGetEditor.subscribe(function (ev, byref_editor) {
        me._grid.fire('getEditor', byref_editor);
      });

      // Для планшетов и сматфонов отключаем клавиатурную навигацию.
      if (!WA.ENV.isTouch()) {
        /**
        * Клавиатурная навигация:
        * Добавление и удаление строк при перемещении курсора вниз.
        */
        var lastActiveCell; // Вынесена тут, что бы в событиях addRow и deleteRow были актуальные данные, получаемые по этой ссылке.
        var needRestoreEditorAfterReload = false;

        grid.onKeyDown.subscribe(function (e, args) {
          var key = e.keyCode;
          var table = me._grid._table;
          if (!table || table.isDisabled()) return;
          var rows = table.rows.toArray();
          var lastRow = rows[rows.length - 1];
          lastActiveCell = [rows.length - 1, args.cell];
          var grid = me._grid.grid;

          // Что бы много раз не биндись, а вынести их события не получается, т.к. table появляется не сразу.
          if (me._bindedTables.indexOf('addRow' + me._grid.settings.DFMName) === -1) {
            //До добавления новой строки вызываем сохранение выбранного значения в текущем редакторе, что бы оно ушло в datasource и потом сохранилось в БД (замечание №103950).
            table.bind(table.class.EVENT.BEFORE_ROW_ADDED, () => {
              const editor = grid.getCellEditor();
              if (!!editor) {
                editor.commit();
              }
            });

            // Смещаем фокус на новую строку в ту же ячейку что и на предыдущей.
            table.bind(table['class'].EVENT.ROW_ADDED, function (row) {
              log.info('DETAILGRID', 'addRow event in EditPlugin');                            
              lastActiveCell[0] = grid.getDataLength() - 1;
              grid.setActiveCell(lastActiveCell[0], lastActiveCell[1]);              
              grid.editActiveCell();             
              //После добавления строки данные могут обновиться, поэтому востанавливаем редактируемую ячейку после загрузки данных.
              needRestoreEditorAfterReload = true;
            });

            me._bindedTables.push('addRow' + me._grid.settings.DFMName);
          }

          // Что бы много раз не биндись, а вынести их события не получается, т.к. table появляется не сразу.
          if (me._bindedTables.indexOf('deleteRow' + me._grid.settings.DFMName) === -1) {
            table.bind('deleteRow', function (row) {
              log.info('DETAILGRID', 'deleteRow event in EditPlugin');
              setTimeout(function () { //что бы не перескакивало 1 строку
                lastActiveCell[0] = grid.getDataLength() - 1;
                grid.setActiveCell(lastActiveCell[0], lastActiveCell[1]);
                grid.editActiveCell();

                //После удалении строки данные могут обновиться, поэтому востанавливаем редактируемую ячейку после загрузки данных.
                needRestoreEditorAfterReload = true;
              }, 100);
            });
            me._bindedTables.push('deleteRow' + me._grid.settings.DFMName);
          }

          // Что бы много раз не биндись, а вынести их события не получается, т.к. table появляется не сразу.
          if (me._bindedTables.indexOf('dataReloaded' + me._grid.settings.DFMName) === -1) {
            table.bind(table['class'].EVENT.DATA_RELOADED, function (row) {
              log.info('DETAILGRID', 'dataReloaded event in EditPlugin');
              if (needRestoreEditorAfterReload) {                
                grid.setActiveCell(lastActiveCell[0], lastActiveCell[1]);
                grid.editActiveCell();
                needRestoreEditorAfterReload = false;
              }
            });
            me._bindedTables.push('dataReloaded' + me._grid.settings.DFMName);
          }

          if (key === $.ui.keyCode.DOWN) {
            if (args.row + 1 == grid.getDataLength()) {
              if (lastRow.hasFilledRequisites()) {
                table.addRow();
              }
            }
          }

          if (key === $.ui.keyCode.UP) {
            if (args.row + 1 == grid.getDataLength()) {
              if (!lastRow.hasFilledRequisites()) {
                lastRow.remove()
              }
            }
          }
        });
      }

      /**
      * Навешиваем события, чтобы при клике на таблицу добавлялась новая строка
      * @since 5.2.0.1303
      */
      WA.DetailsInit.done(function () {
        $(document).on('mouseup.editplugin', $.proxy(me._onFocusOrUnFocus, me));
      })
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * При фокусе на таблицу добавлем новую строку если таблица пустая и Удаляем созданную строку при потере фокуса
    * @since 5.2.0.1303
    */
    _onFocusOrUnFocus: function (e) {
      var me = this;

      var targetInExceptions = function (target) {
        var result = !!_(me._exceptions).find(function (ex) {
          return $(target).hasAncestor(ex).length
        });
        return result;
      }

      var container = $(me._grid.containerSelector);
      var target = e.target;

      // В IE10 c SVG работать надо не так как обычно https://stackoverflow.com/questions/33672395/use-within-svg-not-finding-closest-div-in-ie
      if (target.correspondingUseElement) {
        target = target.correspondingUseElement;

        // Поднимаемся до уровня оборачивающей svg div'ки. Тут target - use, target.parentNode - SvgElement.
        target = target.parentNode.parentNode;
      }

      //FIX #5667: В IE при нажатии на скролбар в выпадающем списке, снивается фокус с input и ставится на div с выпадающим списком, поэтому проверяем текущий зафокусированный элемент на исключения.

      if (!container.is(target) && !container.has(target).length && !targetInExceptions(target) && !targetInExceptions(document.activeElement) && !$(target).hasClass('rs_container')) {
        // Нажали мышкой не в область грида (focusout, blur).
        log.info('DETAILGRID', 'onBlur event in EditPlugin');

        // Если кликнули на другой грид (не текущий обрабатываемый) или вообще в пустое место, что бы текущий не сбросил key scope. 
        window._needSetGridsKeyScope = window._needSetGridsKeyScope || false;

        var table = me._grid._table;
        if (!table || !table.rows) return;

        me._grid.grid.navigateUp();
        me._grid.grid.resetActiveCell();
        me._grid.grid.setSelectedRows([]);

        var rows = table.rows.toArray();
        var lastRow = rows[rows.length - 1];
        if (rows.length === 1 && lastRow && !lastRow.hasFilledRequisites()) {
          lastRow.remove();
        }
        // Убрать режим редактирования с текущей ячейки
        me._grid.grid.setActiveCell(null);
        me._grid.grid.setSelectedRows([]);

        me.isFocused = false;
      } else {
        var targetNode = $(target);
        //#108739         
        if (targetNode.length && (targetNode.hasClass('rs_td') || $('.ui-datepicker').has(targetNode).length || $('.contextmenu__item').has(targetNode).length ||
          targetNode.hasClass('rs_RefCaption') || targetNode.hasClass('rs_results') || targetNode.hasClass('rs_container') ||
          targetNode[0].nodeName.toLowerCase() === "html")) {
          return;
        }

        // Нажали мышкой в область грида (focusin, focus).        
        // Кликнули на грид надо что бы key scope стал равен grid в любом случае (даже если другие гриды хотят поменять его на общий). 
        window._needSetGridsKeyScope = true;

        // if (!me.isFocused) { // #108827
        log.info('DETAILGRID', 'onFocus event in EditPlugin');
        var table = me._grid._table;
        if (table && !table.isDisabled() && !table.rows.count()) table.addRow();

        me.isFocused = true;
        //}
      }

      // Устанавливаем область глобального обработчика горячих клавишь.
      // Через timeout, что бы остальные гридов не сбросили key scope.
      clearTimeout(window._setGridsKeyScopeTimeout);
      window._setGridsKeyScopeTimeout = setTimeout(function () {
        var globalKeyScope;

        if (window._needSetGridsKeyScope) {
          globalKeyScope = 'grid';
        } else {
          globalKeyScope = $('.ui-dialog').length ? 'baseDialog' : 'common';
        }
        key.setScope(globalKeyScope);

        window._needSetGridsKeyScope = false;
      }, 50);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Назначивание редакторов для колонок
    * @method WebAccess.components.dataViews.gridPlugins.EditPlugin#_onGridInit
    * @private
    * @since 5.2.0.1100
    */
    _onColumnInit: function (byref_column) {
      switch (+byref_column.type) {
        case REQUISITE_TYPE.STRING:
          byref_column.editor = function (args) {
            return new global._editors.StringEditor(args);
          };
          break;

        case REQUISITE_TYPE.TEXT:
          byref_column.editor = function (args) {
            return new global._editors.TextEditor(args);
          };
          break;

        case REQUISITE_TYPE.REFERENCE:
          byref_column.editor = function (args) {
            return new global._editors.ReferenceEditor(args);
          };
          break;

        case REQUISITE_TYPE.PICK:
          byref_column.editor = function (args) {
            return new global._editors.PickEditor(args);
          };
          break;

        case REQUISITE_TYPE.DATE:
          byref_column.editor = function (args) {
            return new global._editors.DateEditor(args);
          };
          break;

        case REQUISITE_TYPE.LARGE_INTEGER:
        case REQUISITE_TYPE.INTEGER:
          byref_column.editor = function (args) {
            return new global._editors.IntegerEditor(args);
          };
          break;

        case REQUISITE_TYPE.FLOAT:
          byref_column.editor = function (args) {
            return new global._editors.FloatEditor(args);
          };
          break;

        case REQUISITE_TYPE.DOCUMENT:
          byref_column.editor = function (args) {
            return new global._editors.DocumentEditor(args);
          };
          break;
      }
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//         
  });

})(WA.components.dataViews.gridPlugins);